export enum PaymentError {
  CHARGE_INSUFFICIENT_FUNDS = 'CHARGE_INSUFFICIENT_FUNDS',
  CHARGE_DO_NOT_HONOR = 'CHARGE_DO_NOT_HONOR',
  PAYMENT_METHOD_EXPIRED = 'PAYMENT_METHOD_EXPIRED',
  INVALID_VERIFICATION_TOKEN = 'INVALID_VERIFICATION_TOKEN',
  PAYMENT_METHOD_DISABLED = 'PAYMENT_METHOD_DISABLED',
  UNKNOWN = 'UNKNOWN',
}
